import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const regscale = defineConnector({
  identifier: "regscale",
  name: "RegScale",
  tagLine: "Continuous compliance automation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) => domainToRegex(domain),
  auth: (app) => bearerAuth(app.secret.token),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In RegScale, navigate to your profile settings to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
        {
          kind: "hostname",
          label: "Domain",
          placeholder: "your-instance.regscale.com",
          required: true,
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/status`,
  },
});
